document.addEventListener('DOMContentLoaded', () => {
  const minQty = 6;

  // Find all cart line items
  const cartItems = document.querySelectorAll('[data-cart-item]');

  cartItems.forEach((item) => {
    // Get product tags from a data attribute (we’ll add this in Liquid)
    const tags = item.dataset.productTags ? item.dataset.productTags.split(',') : [];
    const qtyInput = item.querySelector('input[name^="updates"]');

    if (tags.includes('border_color') && qtyInput) {
      // Enforce min quantity on load
      if (parseInt(qtyInput.value) < minQty) {
        qtyInput.value = minQty;
      }

      // Watch for user changes
      qtyInput.addEventListener('change', () => {
        const val = parseInt(qtyInput.value);
        if (val < minQty) {
          alert(`Minimum order quantity for this product is ${minQty}.`);
          qtyInput.value = minQty;

          // Optionally auto-update the cart form
          const cartForm = qtyInput.closest('form[action="/cart"]');
          if (cartForm) cartForm.submit();
        }
      });
    }
  });
});
